import { useQuery } from '@tanstack/react-query';
import { useAdminUserSession } from '../../../models/hooks/adminStateHooks';

interface AccountBillingInfo {
	billingReferenceId: number | null;
}

interface AccountResponse {
	planDetails?: {
		billingReferenceId?: number;
	};
}

export function useAccountBillingInfoQuery({ accountId, enabled = true }: { accountId: string; enabled?: boolean }) {
	const userSession = useAdminUserSession();

	return useQuery({
		queryKey: ['accountBillingInfo', accountId],
		queryFn: async (): Promise<AccountBillingInfo> => {
			const response = await userSession.webServiceHelper.callAsync<AccountResponse>(
				`admin/account/${encodeURIComponent(accountId)}`,
				'GET'
			);

			return {
				billingReferenceId: response?.planDetails?.billingReferenceId ?? null,
			};
		},
		enabled: enabled && !!accountId,
		staleTime: 5 * 60 * 1000, // 5 minutes
	});
}
